<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="title">
          <el-input
            v-model="listQuery.title"
            placeholder="请输入文章名称"
            clearable
            @keyup.enter.native="SearchData"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="SearchData"
          >搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button
          v-auth="'Article.create'"
          class="action-item"
          type="primary"
          icon="el-icon-edit"
          @click="HandleCreate"
        >添加</el-button>
        <el-button
          v-auth="'Article.delete'"
          class="action-item"
          icon="el-icon-delete"
          @click="BatchDelete"
        >删除</el-button>
      </el-button-group>
    </div>

    <div class="clearfix"></div>

    <el-tabs v-model="activeTabIndex">
      <el-tab-pane label="内容列表" name="0" />
      <el-tab-pane label="智能审核(0)" name="1" />
      <el-tab-pane label="回收站" name="2" />
      <el-tab-pane label="已归档" name="3" />
    </el-tabs>

    <div class="article-filter">
      <el-form inline>
        <el-form-item label="排序方式">
          <el-select v-model="listQuery.orderType" placeholder="排序方式" style="width: 150px;">
            <el-option label="默认排序" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="内容状态">
          <el-select v-model="listQuery.status" placeholder="内容状态" style="width: 150px;">
            <el-option label="所有" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="内容类型">
          <el-select v-model="listQuery.contentType" placeholder="内容类型" style="width: 150px;">
            <el-option label="所有" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox>我创建的</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox>重新编辑</el-checkbox>
        </el-form-item>
        <el-form-item>
          <div class="btn-input">
            <el-input placeholder="请输入标题" />
            <el-button icon="el-icon-search" type="primary"></el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">高级搜索</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="article-list">
      <div v-for="item in 10" class="article-item">
        <div class="content">
          <el-row :gutter="20">
            <el-col :span="24" :xl="12">
              <div class="title-container">
                <el-checkbox></el-checkbox>
                <div class="title-tag">[三抓三促]</div>
                <div class="title">
                  【三抓三促·主动创稳·铸忠诚警魂】甘南公安全力做好春节期间大型活动维稳安保工作
                </div>
              </div>
            </el-col>
            <el-col :span="24" :xl="12">
              <div class="article-info">
                <div>创建人：admin</div>
                <div>创建时间：2024-02-26 10:00:00</div>
                <div>ID：39242</div>
                <div>模型：新闻</div>
                <div>访问量：406</div>
                <div>访问人数：1</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="footer">
          <div class="left">
            <el-tag type="primary">已发布</el-tag>
            <el-tag type="success" style="margin-left: 20px;">置顶</el-tag>
          </div>
          <div class="right">
            <el-button
              type="text"
              icon="el-icon-edit-outline"
              @click="editVisible = true"
            >编辑</el-button>
            <el-button type="text" icon="el-icon-s-promotion">发布</el-button>
            <el-button type="text" icon="el-icon-download">下线</el-button>
            <el-button type="text" icon="el-icon-close">删除</el-button>
            <el-button type="text" icon="el-icon-document">预览</el-button>
            <el-button type="text" icon="el-icon-view">浏览</el-button>
            <el-button type="text" icon="el-icon-sort">移动</el-button>
            <el-dropdown style="margin-left: 20px;">
              <el-button
                class="el-dropdown-link"
                type="text"
                icon="el-icon-more"
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  icon="el-icon-upload2"
                >取消置顶</el-dropdown-item>
                <el-dropdown-item
                  icon="el-icon-document-copy"
                >复制</el-dropdown-item>
                <el-dropdown-item icon="el-icon-sort-up">排序</el-dropdown-item>
                <el-dropdown-item
                  icon="el-icon-paperclip"
                >引用</el-dropdown-item>
                <el-dropdown-item>推送到站群</el-dropdown-item>
                <el-dropdown-item>推送到微信</el-dropdown-item>
                <el-dropdown-item>推送到微博</el-dropdown-item>
                <el-dropdown-item
                  icon="el-icon-receiving"
                >归档</el-dropdown-item>
                <el-dropdown-item
                  icon="el-icon-view"
                >访问记录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="文章编辑" :visible.sync="editVisible" fullscreen>
      <div class="article-edit-container">
        <div class="head-bar">
          <div class="item">
            <el-dropdown>
              <el-button type="text" icon="el-icon-receiving">
                保存<i class="el-icon-caret-bottom"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>黄金糕</el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item">
            <el-button type="text" icon="el-icon-s-promotion">发布</el-button>
          </div>
          <div class="item">
            <el-button type="text" icon="el-icon-download">下线</el-button>
          </div>
          <div class="item">
            <el-dropdown>
              <el-button type="text" icon="el-icon-document">
                预览<i class="el-icon-caret-bottom"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>黄金糕</el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item">
            <el-dropdown>
              <el-button type="text" icon="el-icon-menu">
                设置类型<i class="el-icon-caret-bottom"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>黄金糕</el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item">
            <el-dropdown>
              <el-button type="text">
                推送<i class="el-icon-caret-bottom"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>黄金糕</el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item">
            <el-button type="text" icon="el-icon-delete-solid">删除</el-button>
          </div>
          <div class="item">
            <el-dropdown>
              <el-button type="text">
                更多<i class="el-icon-caret-bottom"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>黄金糕</el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <div style="height: 10px;"></div>

        <el-form label-width="70px" label-position="left">
          <el-row :gutter="20" style="display: flex;">
            <el-col style="flex: auto;width: 0;">
              <div class="article-edit-block article-edit-title">
                <el-form-item label="标题：">
                  <el-input
                    v-model="editValue.title"
                    placeholder="请输入标题"
                    type="textarea"
                    maxlength="100"
                    show-word-limit
                  />
                </el-form-item>
              </div>
              <div class="article-edit-block article-edit-sub-title">
                <el-form-item label="副标题：">
                  <el-input
                    v-model="editValue.subTitle"
                    placeholder="请输入副标题"
                    maxlength="50"
                    show-word-limit
                  />
                </el-form-item>
              </div>
              <div class="article-edit-block block-two">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="发布时间：">
                      <el-date-picker
                        v-model="editValue.createTime"
                        type="datetime"
                        placeholder="请选择发布时间"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="padding-left: 20px">
                    <el-form-item label="作者：" label-width="42px">
                      <el-input
                        v-model="editValue.author"
                        placeholder="请输入作者"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div class="article-edit-block">
                <el-form-item label="摘要：">
                  <el-input
                    v-model="editValue.description"
                    placeholder="请输入摘要"
                    type="textarea"
                    :rows="6"
                    maxlength="100"
                    show-word-limit
                  />
                </el-form-item>
              </div>
              <div class="article-edit-block label-top">
                <el-form-item label="单图上传：" label-position="top">
                  <div class="image-upload-group">
                    <FileList
                      v-model="editValue.img_url_attachment"
                      :item-width="150"
                      :item-height="150"
                      :limit="1"
                      type="image"
                      tips="新闻列表图"
                    />
                    <FileList
                      v-model="editValue.img_url_attachment"
                      :item-width="150"
                      :item-height="150"
                      :limit="1"
                      type="image"
                      tips="新闻分享图"
                    />
                    <FileList
                      v-model="editValue.img_url_attachment"
                      :item-width="150"
                      :item-height="150"
                      :limit="1"
                      type="image"
                      tips="新闻手机banner图"
                    />
                    <FileList
                      v-model="editValue.img_url_attachment"
                      :item-width="150"
                      :item-height="150"
                      :limit="1"
                      type="image"
                      tips="手机列表图"
                      style="margin-right: 0;"
                    />
                    <FileList
                      v-model="editValue.img_url_attachment"
                      :item-width="150"
                      :item-height="150"
                      :limit="1"
                      type="image"
                      tips="标题图"
                    />
                    <FileList
                      v-model="editValue.img_url_attachment"
                      :item-width="150"
                      :item-height="150"
                      :limit="1"
                      type="image"
                      tips="内容图"
                    />
                    <FileList
                      v-model="editValue.img_url_attachment"
                      :item-width="150"
                      :item-height="150"
                      :limit="1"
                      type="image"
                      tips="类型图"
                    />
                  </div>
                </el-form-item>
              </div>

              <div class="article-edit-editor">
                <div class="label">正文</div>
                <el-form-item prop="content" label-width="0">
                  <ComposeEditor v-model="editValue.content" />
                  <!-- <WangEditor v-model="temp.content" :value.sync="temp.content" /> -->
                </el-form-item>
              </div>
            </el-col>
            <el-col style="flex: none;width: 350px;">
              <div class="article-edit-block1">
                <el-form-item label="内容模型：" label-width="70px">
                  <el-input
                    v-model="editValue.contentType"
                    placeholder="内容模型"
                  />
                </el-form-item>
              </div>
              <div class="article-edit-block1 label-top">
                <el-form-item label="所属栏目：">
                  <el-select v-model="editValue.type" style="width: 100%">
                    <el-option label="三抓三促" :value="0" />
                  </el-select>
                </el-form-item>
              </div>
              <div class="article-edit-block1 label-top">
                <el-form-item label="来源：">
                  <el-input
                    v-model="editValue.origin"
                    placeholder="请输入来源"
                  />
                </el-form-item>
                <el-form-item style="margin-top: 10px;">
                  <el-input
                    v-model="editValue.originUrl"
                    placeholder="http://"
                  />
                </el-form-item>
              </div>
              <div class="article-edit-block1 label-top">
                <el-form-item label="tag词：">
                  <el-input
                    v-model="editValue.tags"
                    placeholder="多个tag词用逗号隔开"
                  />
                </el-form-item>
              </div>
              <div class="article-edit-block1 label-top">
                <el-form-item label="发布平台：">
                  <el-checkbox-group v-model="editValue.platforms">
                    <el-checkbox label="PC"></el-checkbox>
                    <el-checkbox label="H5"></el-checkbox>
                    <el-checkbox label="APP"></el-checkbox>
                    <el-checkbox label="MP"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
              <div class="article-edit-block1 label-top">
                <el-form-item label="内容PC端模板：">
                  <el-select
                    v-model="editValue.pcTemplate"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option label="请选择" :value="0" />
                  </el-select>
                </el-form-item>
              </div>
              <div class="article-edit-block1 label-top">
                <el-form-item label="内容手机端模板：">
                  <el-select
                    v-model="editValue.mobleTemplate"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option label="请选择" :value="0" />
                  </el-select>
                </el-form-item>
              </div>
              <div class="article-edit-block1 label-top">
                <el-form-item label="评论设置：">
                  <el-radio-group v-model="editValue.commentSetting">
                    <el-radio label="允许游客评论"></el-radio>
                    <el-radio label="登录后评论"></el-radio>
                    <el-radio label="不允许评论"></el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div class="article-edit-block1 label-top">
                <el-form-item label="浏览设置：">
                  <el-radio-group v-model="editValue.viewSetting">
                    <el-radio label="允许访客访问"></el-radio>
                    <el-radio label="登录后访问"></el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div class="article-edit-block1 label-top">
                <el-form-item label="外部链接：">
                  <el-input
                    v-model="editValue.outerLink"
                    placeholder="请输入外部链接"
                  />
                </el-form-item>
                <el-form-item>
                  <el-checkbox
                    v-model="editValue.outerLinkBlank"
                  >新窗口打开外部链接</el-checkbox>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>

    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <!--列开始-->
      <!-- <el-table-column type="selection"></el-table-column> -->
      <el-table-column type="selection"></el-table-column>
      <el-table-column
        type="index"
        label="序号"
        width="55"
        :index="indexMethod"
        align="center"
      />
      <el-table-column align="center" prop="title" label="文章标题">
      </el-table-column>
      <el-table-column
        align="center"
        prop="img_url_attachment"
        label="文章配图"
      >
        <template #default="scope">
          <AttachmentImage
            :src="scope.row.img_url_attachment"
            width="150px"
            height="150px"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="source" label="来源">
      </el-table-column>
      <el-table-column align="center" prop="order_no" label="排序" sortable>
      </el-table-column>
      <el-table-column
        align="center"
        prop="create_time"
        width="180"
        label="添加时间"
        sortable
      ></el-table-column>
      <el-table-column
        align="center"
        prop=""
        label="操作"
        width="270"
        class-name="action"
      >
        <template slot-scope="scopes">
          <el-button
            v-auth="'Article.edit'"
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="Copy(scopes.row)"
          >复制</el-button>
          <el-button
            v-auth="'Article.edit'"
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="HandleUpdate(scopes.row)"
          >编辑</el-button>
          <el-button
            v-auth="'Article.delete'"
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click="RowDelete(scopes.row)"
          >删除</el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />
    <!--弹窗编辑/新增窗体-->
    <el-dialog
      :title="dialogStatus == 'create' ? '新增' : '编辑'"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-width="110px"
        style="width: 100%;"
      >
        <template>
          <el-form-item label="文章标题" prop="title">
            <el-input v-model="temp.title" />
          </el-form-item>
          <el-form-item label="文章来源" prop="source">
            <el-input v-model="temp.source" />
          </el-form-item>
          <el-form-item label="发布平台" prop="release">
            <el-input v-model="temp.release" />
          </el-form-item>
          <el-form-item label="文章简介" prop="desc">
            <el-input
              v-model="temp.desc"
              type="textarea"
              autosize
              placeholder="请输入文章简介"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="status">
            <el-switch
              v-model="temp.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="0"
              :inactive-value="1"
            ></el-switch>
          </el-form-item>
          <el-form-item label="文章配图" prop="img_url_attachment">
            <FileList
              v-model="temp.img_url_attachment"
              :item-width="360"
              :item-height="150"
              :limit="1"
              type="image"
            />
          </el-form-item>
          <el-form-item label="显示排序" prop="order_no">
            <span slot="label">
              <el-tooltip content="排序号越小越靠前" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              显示排序
            </span>
            <el-input-number
              v-model="temp.order_no"
              :min="1"
              :precision="0"
            ></el-input-number>
          </el-form-item>
        </template>

        <el-form-item label="内容" prop="content">
          <ComposeEditor v-model="temp.content" />
          <!-- <WangEditor v-model="temp.content" :value.sync="temp.content" /> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/article' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import FileList from '@/components/attachment/FileList'
import AttachmentImage from '@/components/attachment/AttachmentImage'
import ComposeEditor from '@/components/ComposeEditor'

export default {
  name: 'Article',
  components: { Pagination, FileList, AttachmentImage, ComposeEditor },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        title: [
          {
            required: true,
            message: '请输入文章名称',
            trigger: ['blur']
          }
        ],
        content: [{ required: true, message: '请输入内容', trigger: ['blur'] }]
      },
      temp: {},
      activeTabIndex: '0',
      editVisible: false,
      editValue: {
        platforms: []
      },
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id',
        orderType: 0,
        status: 0,
        contentType: 0
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    Copy(row) {
      this.api.Copy(row.id).then(response => {
        this.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 2000
        })
        this.SearchData()
      })
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 9999,
        source: '',
        status: 0
      }
    }
  }
}
</script>
